import { comics } from '@/mocks/comics';
import { categories } from '@/mocks/categories';
import type { Comic, Category, Chapter } from '@/types/comic';

export function getAllComics(): Comic[] {
  return comics;
}

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getCategoryById(id: string): Category | undefined {
  return categories.find((c) => c.id === id);
}

export function getComicsByCategory(type: string): Comic[] {
  return comics.filter((c) => c.categories.includes(type));
}

export function getRelatedComics(comic: Comic, limit = 4): Comic[] {
  const sameCategory = comics.filter(
    (c) => c.id !== comic.id && c.categories.some((cat) => comic.categories.includes(cat)),
  );
  const rest = comics
    .filter((c) => c.id !== comic.id && !sameCategory.includes(c))
    .sort((a, b) => b.popularity - a.popularity);
  return [...sameCategory, ...rest].slice(0, limit);
}

export function searchComics(keyword: string): Comic[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return comics.filter((c) => {
    const haystack = [c.title, c.author, c.description, ...c.tags].join(' ').toLowerCase();
    return haystack.includes(kw);
  });
}

export function getHotComics(limit = 8): Comic[] {
  return [...comics].sort((a, b) => b.popularity - a.popularity).slice(0, limit);
}

export function getLatestComics(limit = 8): Comic[] {
  return [...comics]
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, limit);
}

export function getFeaturedComics(): Comic[] {
  return ['c01', 'c03', 'c12', 'c07']
    .map((id) => getComicById(id))
    .filter((c): c is Comic => Boolean(c));
}

export function buildChapters(comic: Comic): Chapter[] {
  const total = comic.chapterCount;
  const list: Chapter[] = [];
  for (let i = total; i >= 1; i -= 1) {
    list.push({
      index: i,
      title: i === total ? comic.latestChapter : `第${i}话`,
      date: comic.updateDate,
    });
  }
  return list;
}

export function formatPopularity(value: number): string {
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  return String(value);
}